
import React from 'react';

const Cell = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			fill='none'
			viewBox='0 0 32 32'
		>
			<path
				fill='#2d2d2d'
				d='M25.5 14c-.92 0-1.72.51-2.15 1.25l-2.4-.27a4.465 4.465 0 00-1.52-2.88l1.14-2.15c.14.03.28.05.43.05 1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3c0 .78.31 1.49.8 2.02l-1.14 2.15c-.37-.1-.76-.17-1.16-.17-.97 0-1.87.32-2.61.85l-3.23-2.88c.21-.45.34-.94.34-1.47C11 5.57 9.43 4 7.5 4S4 5.57 4 7.5 5.57 11 7.5 11c.67 0 1.3-.2 1.83-.53l3.24 2.88c-.35.64-.57 1.37-.57 2.15 0 .46.09.9.22 1.32l-3.29 1.9C8.41 18.28 7.74 18 7 18c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3c0-.19-.02-.37-.06-.55l3.27-1.9c.83.89 1.99 1.45 3.29 1.45.05 0 .1-.01.15-.01l.67 2.54c-.8.53-1.32 1.44-1.32 2.47 0 1.65 1.35 3 3 3s3-1.35 3-3c0-1.57-1.21-2.84-2.75-2.97l-.67-2.56c1-.53 1.77-1.41 2.15-2.49l2.39.27A2.5 2.5 0 0025.5 19a2.5 2.5 0 000-5zM21 6c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM7 22c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm13 3c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zM7.5 9C6.67 9 6 8.33 6 7.5S6.67 6 7.5 6 9 6.67 9 7.5 8.33 9 7.5 9zm9 9a2.5 2.5 0 010-5 2.5 2.5 0 010 5zm9-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5z'
			></path>
		</svg>
	);
};

export default Cell;
